import { useShow, useNavigation } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Card, Descriptions, Tag, Row, Col, Switch, message, Button, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { apiClient } from '../../lib/api-client';
import { ActivityLogList } from './ActivityLogList';

interface Staff {
  id: number;
  username: string;
  fullName: string | null;
  phone: string | null;
  isActive: boolean;
  createdAt: string;
  lastLoginAt: string | null;
  permissions: Record<string, string[]>;
}

const permissionLabels: Record<string, string> = {
  read: 'Ko\'rish',
  create: 'Yaratish',
  update: 'Tahrirlash',
  delete: 'O\'chirish',
  block: 'Bloklash',
  verify: 'Tasdiqlash',
  review: 'Ko\'rib chiqish',
  reply: 'Javob berish',
  resolve: 'Hal qilish',
  cancel: 'Bekor qilish',
};

const groupLabels: Record<string, string> = {
  users: 'Foydalanuvchilar',
  drivers: 'Haydovchilar',
  documents: 'Hujjatlar',
  trips: 'Sayohatlar',
  payments: 'To\'lovlar',
  support: 'Murojatlar',
  faq: 'FAQ',
  promo: 'Promo kodlar',
  settings: 'Sozlamalar',
  staff: 'Xodimlar',
};

export const StaffShow = () => {
  const { edit } = useNavigation();
  const { queryResult } = useShow<Staff>();
  const { data, isLoading, refetch } = queryResult;
  const staff = data?.data;

  const handleToggleActive = async (checked: boolean) => {
    try {
      await apiClient.put(`/admin/staff/${staff?.id}`, { isActive: checked });
      message.success(checked ? 'Xodim faollashtirildi' : 'Xodim o\'chirildi');
      refetch();
    } catch {
      message.error('Xatolik yuz berdi');
    }
  };

  return (
    <Show
      isLoading={isLoading}
      title={`Xodim: ${staff?.fullName || staff?.username}`}
      headerButtons={
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => edit('admin/staff', staff?.id || 0)}
          >
            Tahrirlash
          </Button>
        </Space>
      }
    >
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={12}>
          <Card title="Asosiy ma'lumotlar">
            <Descriptions column={1}>
              <Descriptions.Item label="ID">{staff?.id}</Descriptions.Item>
              <Descriptions.Item label="Login">{staff?.username}</Descriptions.Item>
              <Descriptions.Item label="To'liq ism">
                {staff?.fullName || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Telefon">
                {staff?.phone || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Holat">
                <Switch
                  checked={staff?.isActive}
                  onChange={handleToggleActive}
                  checkedChildren="Faol"
                  unCheckedChildren="Nofaol"
                />
              </Descriptions.Item>
              <Descriptions.Item label="Yaratilgan">
                {staff?.createdAt
                  ? new Date(staff.createdAt).toLocaleString('uz-UZ')
                  : '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Oxirgi kirish">
                {staff?.lastLoginAt
                  ? new Date(staff.lastLoginAt).toLocaleString('uz-UZ')
                  : '-'}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="Ruxsatlar">
            {staff?.permissions &&
              Object.entries(staff.permissions).map(([group, perms]) => (
                <div key={group} style={{ marginBottom: 12 }}>
                  <div style={{ fontWeight: 500, marginBottom: 4 }}>
                    {groupLabels[group] || group}
                  </div>
                  <div>
                    {(perms as string[]).map((perm) => (
                      <Tag key={perm} color="blue" style={{ marginBottom: 4 }}>
                        {permissionLabels[perm] || perm}
                      </Tag>
                    ))}
                    {(perms as string[]).length === 0 && (
                      <span style={{ color: '#7F8C8D' }}>Ruxsat yo'q</span>
                    )}
                  </div>
                </div>
              ))}
          </Card>
        </Col>

        {/* Activity Log */}
        <Col xs={24}>
          {staff?.id && (
            <ActivityLogList
              staffId={staff.id}
              embedded
              title="Xodim faoliyati"
            />
          )}
        </Col>
      </Row>
    </Show>
  );
};
